import { chatQueryKeys as e } from "../hooks/useChatQueryKeys.mjs";
import { chatApi as t } from "@maat/api-chat";
//#region src/transport/consumerChatTransport.ts
var n = {
	api: t,
	keys: {
		messages: e.messages,
		internalNotes: e.internalNotes,
		summary: e.summary,
		conversations: () => e.conversations(),
		unread: null
	}
};
//#endregion
export { n as consumerChatTransport };
